import React from 'react';
import { View, TextInput, StyleSheet, ViewStyle } from 'react-native';
import { useAdminColors } from '@/hooks/admin/useAdminColors';
import { useThemedStyles } from '@/hooks/shared/useThemeColors';
import { SVG_COMPONENTS } from '@/assets/admin';

interface SearchBarProps {
  placeholder?: string;
  value: string;
  onChangeText: (text: string) => void;
  style?: ViewStyle;
}

export const SearchBar: React.FC<SearchBarProps> = ({
  placeholder = 'Search',
  value,
  onChangeText,
  style,
}) => {
  const styles = useStyles();
  const { admin, redesign } = useAdminColors();

  return (
    <View style={[styles.container, style]}>
      <SVG_COMPONENTS.MAGNIFYING_GLASS
        width={16}
        height={16}
        color={redesign.text.dim}
        style={styles.icon}
      />
      <TextInput
        style={styles.input}
        placeholder={placeholder}
        value={value}
        onChangeText={onChangeText}
        placeholderTextColor={admin.formInput.placeholder}
        autoCapitalize="none"
        autoCorrect={false}
      />
    </View>
  );
};

const useStyles = () =>
  useThemedStyles(({ components }) => {
    const admin = components.admin;
    return StyleSheet.create({
      container: {
        flexDirection: 'row',
        alignItems: 'center',
        backgroundColor: admin.formInput.bg,
        borderRadius: 8,
        borderWidth: 1,
        borderColor: admin.formInput.border,
        paddingHorizontal: 12,
        height: 40,
      },
      icon: {
        marginRight: 8,
      },
      input: {
        flex: 1,
        fontSize: 14,
        color: admin.formInput.text,
        paddingVertical: 0,
      },
    });
  });
